/**
 * Directive to mark buttons that belong to products that have not been licensed. Depending on some rules
 * the buttons are either grayed out or completely hidden.
 *
 * Usage:
 * <app-icon ... d-requires-product-license="PLAN" hide-unlicensed></app-icon>
 * hide-unlicensed: Don't gray out buttons, but hide them always
 * show-unlicensed: Always show grayed out buttons
 */
angular.module('cfn').directive('dRequiresProductLicense', [
  'requiresProductLicensePopupService',
  function(requiresProductLicensePopupService) {
    return {
      restrict: 'A',
      priority: -1, // Apply before ng-click (prio 0), so we can prevent this as well
      link: function(scope, element, attributes) {
        let requiredProductKey = attributes.dRequiresProductLicense;
        let isProductLicensed = app.credentials.licensedProducts && app.credentials.licensedProducts.indexOf(requiredProductKey) > -1;
        let isProductHidden = app.credentials.hiddenProducts && app.credentials.hiddenProducts.indexOf(requiredProductKey) > -1;

        if (requiredProductKey && !isProductLicensed) {
          let availableProductsInThisCountry = app.credentials.availableProducts;
          let isModuleAvailableInThisCountry = availableProductsInThisCountry.indexOf(requiredProductKey) > -1;

          // hide module if product is hidden
          let completelyHide = isProductHidden || !isModuleAvailableInThisCountry        // hide module if not available in this country
            || ((!('showUnlicensed' in attributes) || !app.credentials.company.shopCountry) // Never hide if this attribute is set
                && ('hideUnlicensed' in attributes      // Always hide if this attribute is set
                || app.credentials.customerGroups.buyerGroup === 'BUYER' // User has bought any other product
                || !app.credentials.company.shopCountry)); // Registration country has no shop yet

          if (completelyHide) {
            // needed because the hasApp directive from gea changes the element visibility in a $observe function and we can't change that.
            element.remove();
          } else if (isModuleAvailableInThisCountry) {
            // Show the module, but grayed out
            element.addClass('notlicensed');
            element.bind('click', function(event) {
              event.preventDefault();
              event.stopImmediatePropagation();

              // Show popup
              requiresProductLicensePopupService.showDialog(requiredProductKey);

              return false;
            });
          }
        }
      },
    };
  },
]);
